window.addEventListener("load", () => {
  setTimeout(() => {
    const bageechaButtons = document.querySelectorAll("#subscribe-bageecha");

    if (!bageechaButtons.length) return;

    bageechaButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        window.location.href = "/checkout";
      });
    });
  }, 3000); // 5s after full load
});


/* ---------------------------
   Track which Week user clicked
---------------------------- */

  // setTimeout(() => {

  //     const productButtons = document.querySelectorAll(".PRODUCT_CARD_ATC_BUTTON_TS");
  //     console.log('productButtons',productButtons);
  //     if (!productButtons.length) return;
  //     productButtons.forEach(btn => {
  //       btn.addEventListener("click", function(e){
  //         e.preventDefault();
  //         const weekContainer = e.target.closest("[id^='Week-']");
  //         if (!weekContainer) return;
  //         console.log('weekContainer',weekContainer);

  //         const productCard = e.target.closest(".productContent-module__card_product__Zs, [data-product-id]");
  //         console.log('productCard',productCard);
  //         if (!productCard) return;

  //         const weekId = weekContainer.id;

  //         const productName =
  //           productCard.querySelector(".productContent-module__product_information_title__mh")?.innerText?.trim();

  //         if (!productName) return;

  //         let mapping = JSON.parse(localStorage.getItem("weekMapping") || "{}");

  //         if (!mapping[weekId]) {
  //           mapping[weekId] = [];
  //         }

  //         if (!mapping[weekId].includes(productName)) {
  //           mapping[weekId].push(productName);
  //         }

  //         localStorage.setItem("weekMapping", JSON.stringify(mapping));

  //         console.log("Stored Mapping:", mapping);

  //       });
  //     });
  // let lastCartCount = 0;

  // async function monitorCart() {

  //   const cart = await fetch("/cart.js").then(r => r.json());

  //   if (cart.item_count > lastCartCount) {

  //     const mapping = JSON.parse(localStorage.getItem("weekMapping") || "{}");

  //     if (!Object.keys(mapping).length) return;

  //     const formatted = Object.entries(mapping)
  //       .map(([week, products]) => `${week}: ${products.join(", ")}`)
  //       .join(" | ");

  //     await fetch("/cart/update.js", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         attributes: {
  //           week_products: formatted
  //         }
  //       })
  //     });

  //     console.log("Added to Order Notes:", formatted);

  //     localStorage.removeItem("weekMapping");
  //   }

  //   lastCartCount = cart.item_count;
  // }

  // fetch("/cart.js")
  //   .then(r => r.json())
  //   .then(cart => lastCartCount = cart.item_count);

  // setInterval(monitorCart, 1500);

  // }, 3000); // 5s after full load
setTimeout(() => {

(function(){

console.log("ATC Button Tracking Started");

/* -----------------------------
   ATTACH LISTENER TO ATC BUTTONS
----------------------------- */

function attachATCListeners() {

  const buttons = document.querySelectorAll(".PRODUCT_CARD_ATC_BUTTON_TS");

  buttons.forEach(btn => {

    /* Prevent duplicate binding */
    if (btn.dataset.weekBound === "true") return;

    btn.dataset.weekBound = "true";

    btn.addEventListener("click", (e) => {
      e.preventDefault();
        const weekContainer = btn.closest("[id^='Week-']");
        if (!weekContainer) return;

        const productCard = btn.closest(".productContent-module__card_product__Zs, [data-product-id]");
        if (!productCard) return;

        const weekId = weekContainer.id;

        const productName =
          productCard.querySelector(".productContent-module__product_information_title__mh")
          ?.innerText?.trim();

        if (!productName) return;

        let mapping = JSON.parse(localStorage.getItem("weekMapping") || "{}");

        if (!mapping[weekId]) mapping[weekId] = [];

        if (!mapping[weekId].includes(productName)) {
          mapping[weekId].push(productName);
        }

        localStorage.setItem("weekMapping", JSON.stringify(mapping));

        console.log("Stored Mapping:", mapping);

    });

  });

}
function attachRemoveListeners() {
  const removeBtns = document.querySelectorAll(".productSelected-module__icon_remove_product__DA");
  // console.log('removeBtns',removeBtns);

  removeBtns.forEach(btn => {

    if (btn.dataset.removeBound === "true") return;

    btn.dataset.removeBound = "true";

    btn.addEventListener("click", () => {
      /* Small delay so builder removes DOM first */
      const productItem = btn.closest(".productSelected-module__product_selected__ST");
      // console.log('productItem',productItem);
        if (!productItem) return;

        const productName = productItem
        .querySelector(".productSelected-module__name_product_selected__UO")
        ?.querySelector("span:first-child")
        ?.innerText?.trim();

        // console.log('productName',productName);
        if (!productName) return;

        let mapping = JSON.parse(localStorage.getItem("weekMapping") || "{}");

        let updated = false;

        Object.keys(mapping).forEach(week => {

          const index = mapping[week].indexOf(productName);

          if (index !== -1) {
            mapping[week].splice(index, 1);
            updated = true;

            /* Remove empty week */
            if (!mapping[week].length) {
              delete mapping[week];
            }
          }

        });

        if (updated) {
          localStorage.setItem("weekMapping", JSON.stringify(mapping));
          console.log("Updated Mapping After Remove:", mapping);
        }

    });

  });

}
function attachClearListeners() {

  const clearBtns = document.querySelectorAll(".footer-module__footer_action__r5");

  clearBtns.forEach(btn => {

    if (btn.dataset.clearBound === "true") return;

    btn.dataset.clearBound = "true";

    btn.addEventListener("click", () => {

      localStorage.removeItem("weekMapping");

      console.log("Week Mapping Cleared");

    });

  });

}

/* -----------------------------
   WATCH THIRD-PARTY DOM CHANGES
----------------------------- */

const observer = new MutationObserver(() => {
  attachATCListeners();
  attachRemoveListeners();

});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* Initial Run */
attachATCListeners();
attachRemoveListeners();


/* -----------------------------
   CART MONITOR
----------------------------- */

let lastCartCount = 0;

async function monitorCart() {

  try {

    const cart = await fetch("/cart.js").then(r => r.json());

    if (cart.item_count > lastCartCount) {

      const mapping = JSON.parse(localStorage.getItem("weekMapping") || "{}");

      if (!Object.keys(mapping).length) return;

      const formatted = Object.entries(mapping)
        .map(([week, products]) => `${week}: ${products.join(", ")}`)
        .join(" | ");

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            week_products: formatted
          }
        })
      });

      console.log("Added To Order:", formatted);

      localStorage.removeItem("weekMapping");
    }

    lastCartCount = cart.item_count;

  } catch(e) {
    console.log("Cart monitor error", e);
  }

}

/* Start Monitoring */
fetch("/cart.js")
  .then(r => r.json())
  .then(cart => lastCartCount = cart.item_count);

setInterval(monitorCart, 1500);

})();


}, 3000); // 5s after full load